module.exports = __webpack_public_path__ + "dist/img/carsaver-ltw-logo.fa17f7b6.png";